import { groupBy, uniqBy, sortBy } from 'lodash';
import { HoldingClassInvestmentsConsiderationValues } from '../../../types';

export const useHoldingClassInvestmentData = (
  holdingClassInvestmentsConsiderationValues: Array<HoldingClassInvestmentsConsiderationValues>,
) => {
  const allHoldingClasses = uniqBy(
    holdingClassInvestmentsConsiderationValues,
    'holdingClassId',
  ).map((holdingClass) => ({
    id: holdingClass.holdingClassId ?? '',
    name: holdingClass.holdingClassName ?? '',
  }));

  const sortedByDate = sortBy(
    holdingClassInvestmentsConsiderationValues,
    (item) =>
      item.investmentDate
        ? new Date(item.investmentDate).getTime()
        : Number.POSITIVE_INFINITY,
  );

  const groupedByInvestment = groupBy(
    sortedByDate,
    (item) => item.investmentId ?? 'unknown',
  );

  return {
    allHoldingClasses,
    groupedByInvestment,
  };
};
